import { render } from "./StartupMessageDialog.vue?vue&type=template&id=b8447b50&ts=true"
import script from "./StartupMessageDialog.vue?vue&type=script&lang=ts"
export * from "./StartupMessageDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__